import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { SolutionsDataSource } from './solutions.datasource';
import { SolutionMapper } from './solutions.mapper';
import { Solution } from '../models/solutions.types';
import { Period } from '../../../core/constants/periods';

@Injectable({ providedIn: 'root' })
export class SolutionsService {
  private dataSource = inject(SolutionsDataSource);
  private mapper = inject(SolutionMapper);

  getSolutions(projectId: string, period: Period): Observable<Solution[]> {
    return this.dataSource
      .getSolutions(projectId, period)
      .pipe(map(responses => this.mapper.mapToSolutions(responses)));
  }
}
